
import { Component, Prop, Vue } from "vue-property-decorator";
import { ReportShowConfigV5Item } from "@/lib/model/exam/result";
import H5ReportDialog from "@/views/paper/paper-result-report/component-new-h5/dialog/index.vue";
import { errorInfoType } from "../result-ai-report";
import {
  CandidateNewResult,
  HandDetectionConfig
} from "@/lib/model/exam/candidate-result";
import AutoReportTag from "./AutoReportTag.vue";
import { replaceBgCheckString } from "@/utils/common";

const tagText: any = {
  resultFlexibleItem: "手指灵活度",
  resultCompleteItem: "手指完整度",
  resultScarItem: "手部疤痕纹身",
  resultArmHideItem: "手部无遮挡",
  resultArmCompleteItem: "手部完整展示"
};

enum errorEnum {
  "screenshotDetection" = "小程序防截屏",
  "mobileJoinCount" = "小程序防切屏",
  "replacementPerson" = "换人检测",
  "multiplePersonDetection" = "多人检测",
  "readingDetection" = "念稿检测",
  "faceDetection" = "人脸核验", //之前 身份认证
  "bgCheck" = "背调结果",
  "bgCheckSocial" = "社会安全风险",
  "bgCheckFinancial" = "金融风险",
  "handDetection" = "手部综合检测",
  "jumpOutDetection" = "Web防切屏",
  "colorDetection" = "辨色检测",
  "faceShowDetection" = "露脸检测",
  "livenessRecognition" = "人脸核验",
  "bgCheckIdentity" = "手机号实名认证",
  "nameIdCheck" = "二要素核验",
  "bodyDetection" = "形体综合检测",
  "hairDetection" = "染发检测",
  "dressingDetection" = "着装检测",
  "smokeDetection" = "吸烟检测",
  "keyboardSoundDetection" = "键盘声音检测",
  "multiVoiceDetection" = "多人声音检测",
  "faceScarDetection" = "面部综合检测"
}

@Component({ components: { H5ReportDialog, AutoReportTag } })
export default class PaperResultReport extends Vue {
  @Prop({ default: () => new CandidateNewResult() }) all!: CandidateNewResult;
  @Prop({}) connectCode!: string;
  @Prop({ default: () => [] }) testList!: any;
  @Prop({ default: () => new ReportShowConfigV5Item() })
  option!: ReportShowConfigV5Item;
  colorRes = { 0: "#5654DC", 1: "#19C976", 2: "#2F91E7", 3: "#F72D20" };
  replaceBgCheckString = replaceBgCheckString;

  get hrResEnum() {
    const enumHr = {
      0: "待评估",
      1: "通过",
      2: "待定",
      3: "拒绝"
    };
    return enumHr[this.all.candidateInfo.auditInfo.auditStatus] || "-";
  }

  get paramList() {
    return this.all.candidateInfo.baseInfo.params.filter(item =>
      [
        "身份证号后6位",
        "身份证号",
        "学历",
        "邮箱",
        "最近一份工作单位",
        "学校",
        "专业",
        "年龄",
        "性别"
      ].includes(item.name)
    );
  }

  get paramListDIY() {
    return this.all.candidateInfo.baseInfo.params.filter(item => {
      return ![
        "编号",
        "姓名",
        "手机",
        "身份证号后6位",
        "身份证号",
        "学历",
        "邮箱",
        "最近一份工作单位",
        "学校",
        "专业",
        "年龄",
        "性别"
      ].includes(item.name);
    });
  }

  get hasErrorItem() {
    return !!this.errorNormalListUsed.filter(item => item.type != 2).length;
  }

  get showErrorTest() {
    return (
      this.Show("hiddenErrorInfo") &&
      this.errorNormalListUsed.length &&
      (this.hasErrorItem || !this.option.optionMap.hiddenNormalTag)
    );
  }
  // 检测项 前端组装
  get errorNormalListUsed() {
    const result: any[] = [];
    const sortOrder = { 1: 1, 0: 2, 2: 3 };
    result.push(...this.errNormalList);
    result.push(...this.errListHand);

    if (result.length > this.defShowLimit && !this.showMoreTest) {
      return result
        .sort((a, b) => sortOrder[a.type] - sortOrder[b.type])
        .slice(0, this.defShowLimit);
    }
    return result.sort((a, b) => sortOrder[a.type] - sortOrder[b.type]);
  }

  get errNormalList() {
    const result: any[] = [];
    this.all.report.errorInfoList.forEach(d => {
      if (d.task === "handDetection") return;
      const item = {
        name: errorEnum[d.task],
        type: d.result,
        task: d.task
      };
      result.push(item);
    });
    return result;
  }

  //手部检测五个细项 前端组装
  get errListHand(): errorInfoType[] {
    const result: any[] = [];
    const list = [
      "resultFlexibleItem",
      "resultCompleteItem",
      "resultScarItem",
      "resultArmHideItem",
      "resultArmCompleteItem"
    ];
    list.forEach(item => {
      if (this.all.report.handDetection.answerNumber > 0) {
        const type = (this.all.report.handDetection[
          item as keyof HandDetectionConfig
        ] as any).all;
        result.push({
          name: tagText[item],
          type: type === 1 ? 2 : type === 2 ? 1 : 0,
          task: "handDetection"
        });
      }
    });
    return result;
  }
  // 枚举
  handTestEnum = {
    resultComplete: "手指完整度",
    resultScar: "手部疤痕纹身",
    resultFlexible: "手指灵活度",
    resultArmHide: "手部无遮挡",
    resultArmComplete: "手部完整展示"
  };

  UILook = false;
  defShowLimit = 6; //基本信息默认最多展示条数
  showMoreParam = false; //是否展开全部基本信息
  showMoreTest = false; //是否展开全部异常检测

  get showMoreTestBtn() {
    console.log(
      this.errNormalList.length,
      this.errListHand.length,
      this.defShowLimit
    );
    return (
      this.errNormalList.length + this.errListHand.length > this.defShowLimit &&
      !this.showMoreTest
    );
  }

  //更多信息按钮 显隐
  get showMoreBtn() {
    return (
      this.paramList.length + this.paramListDIY.length > this.defShowLimit &&
      !this.showMoreParam
    );
  }
  //展示的基本信息list
  get showParamList() {
    let list = [...this.paramList, ...this.paramListDIY];
    if (list.length > this.defShowLimit && !this.showMoreParam) {
      list = list.slice(0, this.defShowLimit);
    }
    return list;
  }

  created() {
    //
  }

  isExceedMaxLine = false;
  isExpand = false;
  setAuditDesc() {
    const auditDesc = this.$refs.auditDesc as HTMLElement;
    const lineHeight = 22;
    const lineNum = 4; // 显示几行
    const paddingY = 12 * 2;
    if (auditDesc) {
      console.log(auditDesc.scrollHeight);
      if (auditDesc.scrollHeight > lineHeight * lineNum + paddingY) {
        this.isExceedMaxLine = true;
      } else {
        this.isExceedMaxLine = false;
      }
    }
  }

  //
  mounted() {
    setTimeout(() => {
      this.setAuditDesc();
    }, 100);
    // this.isStudent = String(this.$route.query.ver || "") === "1";
  }
  //得分底色图
  get getScorebg() {
    return this.all.report.candidate.scoreAi < 10
      ? require("../assets/score-bg1.png")
      : this.all.report.candidate.scoreAi > 99
      ? require("../assets/score-bg3.png")
      : require("../assets/score-bg2.png");
  }
  //展示结果图标
  showResIcon = true;
  get pdtop() {
    return this.showResIcon ? "50px" : "12px";
  }
  //获取结果图标
  get getResIcon() {
    if (this.all.report.candidate.aiRecommendStatus === 0) {
      return "";
    }
    // return AiStatus[this.candidate.aiRecommendStatus] || "";
    //   "不推荐 🤨" = 10,
    // "一般 🙂" = 20,
    // "推荐 👍" = 30,
    // "非常推荐 🥳" = 40
    return require(`../assets/res-icon-${this.all.report.candidate.aiRecommendStatus}.png`);
  }
  //异常状态 class样式
  getErrorStatus(type: number): string {
    return type === 0 ? "warn" : type === 1 ? "error" : "normal";
  }
  //异常状态文本
  getErrorStatusText(type: number): string {
    return type === 0 ? "未检测" : type === 1 ? "异常" : "通过";
  }
  // 需要下载看的文件类型
  isDownloadFileType(url: string): boolean {
    const downType = ["doc", "docx", "pptx", "ppt", "xls", "xlsx"];
    const type = url.split(".")[url.split(".").length - 1];
    return downType.includes(type);
  }
  // 直接看的文件类型
  isShowFileType(url: string): boolean {
    const showType = ["jpg", "jpeg", "png"];
    const type = url.split(".")[url.split(".").length - 1];
    return showType.includes(type);
  }
  //文件格式不支持提示
  showWarning = false;
  showImg(ls: any) {
    if (!this.isShowFileType(ls.cascadeValue)) {
      this.showWarning = true;
      return;
    }
    //查看图片
    this.$emit("openImg", ls.cascadeValue);
  }

  //头像占位
  defImg(event: any) {
    this.all.candidateInfo.baseInfo.photoUrl = "";
    const img = event.srcElement;
    img.onerror = null; //防止闪图
  }

  //模块展示
  public Show(p: string) {
    return true;
  }
  //HR阅过卷
  public get isHrChanged() {
    return (
      this.all.candidateInfo.auditInfo.auditStatus !== 0 &&
      this.all.candidateInfo.auditInfo.auditMember !== "AI"
    );
  }

  anchorTo(key: string): void {
    const refs = {
      faceDetection: "作弊风险检测", //身份核验
      bgCheckSocial: "综合调查评估", //社会安全
      bgCheckFinancial: "综合调查评估", //金融风险
      bgCheck: "综合调查评估", //背调结果
      bgCheckIdentity: "综合调查评估", //手机号实名认证
      colorDetection: "作弊风险检测", //辨色检测
      handDetection: "作弊风险检测", //手部检测
      faceShowDetection: "作弊风险检测", //露脸检测
      replacementPerson: "作弊风险检测", //换人检测
      multiplePersonDetection: "作弊风险检测",
      livenessRecognition: "作弊风险检测", //人脸核验
      screenshotDetection: "作弊风险检测", //小程序防截屏检测
      mobileJoinCount: "作弊风险检测", //小程序防切屏检测
      jumpOutDetection: "作弊风险检测", //Web防切屏检测
      readingDetection: "作弊风险检测", //念稿检测
      nameIdCheck: "背景调查",
      bodyDetection: "形体综合检测",
      hairDetection: "仪容仪表",
      dressingDetection: "仪容仪表",
      smokeDetection: "仪容仪表",
      keyboardSoundDetection: "作弊风险检测",
      multiVoiceDetection: "作弊风险检测",
      faceScarDetection: "仪容仪表"
    };

    const parent = this.$parent;
    if (parent) {
      const dom = parent.$refs[refs[key]];
      if (dom) {
        const element = dom[0].$el; // 获取目标元素
        const elementPosition = element.offsetTop; // 获取目标元素相对于视口的顶部位置
        const offset = 76; // 设置偏移量为fix的导航栏高度
        const targetPosition = elementPosition - offset; // 计算目标滚动位置

        document.body.scrollTo({
          top: targetPosition,
          behavior: "smooth" // 设置滚动行为为平滑滚动
        });
      }
    }
  }

  // 如果有命中了自动化规则的报告评价，则展示报告评价，不展示 errorList 的标签；
  // 如果没有命中自动化规则的报告评价，则按照原先的展示方式展示
  public get isShowAutoRuleReportComment() {
    return this.all.report.reportMessageList.length > 0;
  }
}
